import {
  Button,
  Paper,
  Typography,
  CircularProgress,
  Skeleton,
} from '@mui/material'
import { CameraAlt, FlipCameraIos, RestartAlt } from '@mui/icons-material'
import { LoadingButton } from 'components/mui'
import useParentTrayImageLogic from './ParentTrayImage.logic'
import './ParentTrayImage.scss'
import classNames from 'classnames'

const ParentTrayImage = () => {
  const {
    handleImageCapture,
    videoRef,
    cameras,
    activeCamera,
    isCameraMenuOpen,
    handleSelectCamera,
    handleToggleCameraMenu,
    handleBackClick,
    handleConfirm,
    parentTrayImage,
    recapture,
    isUploading,
  } = useParentTrayImageLogic()

  return (
    <>
      <Paper className="parent-tray-step step-item">
        <div className="parent-tray">
          <div className="camera-section">
            <div className="camera-container">
              {!parentTrayImage && (
                <>
                  {isCameraMenuOpen && (
                    <div className="camera-options">
                      {cameras.map((camera) => (
                        <div
                          key={camera.deviceId}
                          className={classNames('camera-option', {
                            active: camera.deviceId === activeCamera?.deviceId,
                          })}
                          onClick={() => handleSelectCamera(camera)}
                        >
                          <Typography className="label">
                            {camera.label}
                          </Typography>
                          <Typography className="type">
                            {camera?.cameraType}
                          </Typography>
                        </div>
                      ))}
                    </div>
                  )}
                  <LoadingButton
                    variant="contained"
                    loading={false}
                    onClick={handleToggleCameraMenu}
                    startIcon={<FlipCameraIos />}
                    className="camera-switch"
                  >
                    Switch Camera
                  </LoadingButton>
                  <div className="capture-buttons">
                    <LoadingButton
                      className="capture"
                      onClick={() => handleImageCapture(true)}
                      loading={false}
                      variant="text"
                    >
                      <CameraAlt className="icon" />
                    </LoadingButton>
                  </div>
                </>
              )}
              {parentTrayImage ? (
                <div className="image-container">
                  {parentTrayImage.isUploading || isUploading ? (
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height="100%"
                      animation="wave"
                      className="tray-image-skeleton"
                    />
                  ) : (
                    <img
                      src={parentTrayImage.src}
                      alt="Parent Tray"
                      className="tray-image"
                    />
                  )}
                  {parentTrayImage.isUploading && (
                    <div className="upload-overlay">
                      <div className="upload-status">
                        <CircularProgress size={48} color="primary" />
                        <Typography variant="h6" className="upload-text">
                          Uploading Image...
                        </Typography>
                        <Typography variant="body2" className="upload-subtext">
                          Please wait while we process your image
                        </Typography>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <video
                  ref={videoRef}
                  autoPlay
                  muted
                  playsInline
                  className="camera-feed"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center',
                    backgroundColor: '#000',
                  }}
                />
              )}
            </div>
            {parentTrayImage && (
              <div className="action-buttons">
                <Button
                  onClick={recapture}
                  className="recapture-btn"
                  disabled={parentTrayImage.isUploading || isUploading}
                >
                  <RestartAlt sx={{ mr: 0.5 }} />
                  Recapture
                </Button>
              </div>
            )}
          </div>
        </div>
      </Paper>
      <div className="buttons_container">
        <Button variant="outlined" onClick={handleBackClick}>
          Back
        </Button>
        <LoadingButton
          variant="contained"
          disabled={
            !parentTrayImage || parentTrayImage?.isUploading || isUploading
          }
          onClick={handleConfirm}
          loading={parentTrayImage?.isUploading || isUploading}
        >
          {parentTrayImage?.isUploading || isUploading
            ? 'Loading...'
            : 'Confirm'}
        </LoadingButton>
      </div>
    </>
  )
}

export default ParentTrayImage
